import React from 'react'
import ResumeCheckbox from '../ResumeCheckbox'
import { connect } from "react-redux";
import { handleEducationPrivacy } from '../../../../services/actions/actions';

function ContentEducation({ educationDetail,handleEducationPrivacy }) {
    return (
        <>
            <div>
                {educationDetail.map((data, idx) => {
                    const {entries,isHidden} = data
                    return <div key={idx} className='border-b border-gray-300 py-2'>
                        <div>
                            <span className='manpro font-semibold'>{entries.course_title} - </span>
                            <span className='text-sm italic manpro text-gray-600 font-light'>{entries.institute_name}</span>
                        </div>
                        <div>
                            <ResumeCheckbox value={isHidden ? 'noshow' : 'show'} onChange={(e) => handleEducationPrivacy({selectedId: idx, value: e.target.value})}/>
                        </div>
                    </div>
                })}
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        handleEducationPrivacy: (value) => {
            dispatch(handleEducationPrivacy(value))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToState)(ContentEducation)

